var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1813_11512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1644 11H4.83556C4.37409 11 4 11.4209 4 11.94V12.06C4 12.5791 4.37409 13 4.83556 13H19.1644C19.6259 13 20 12.5791 20 12.06V11.94C20 11.4209 19.6259 11 19.1644 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1644 16H4.83556C4.37409 16 4 16.4209 4 16.94V17.06C4 17.5791 4.37409 18 4.83556 18H19.1644C19.6259 18 20 17.5791 20 17.06V16.94C20 16.4209 19.6259 16 19.1644 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1644 6H4.83556C4.37409 6 4 6.42085 4 6.94V7.06C4 7.57915 4.37409 8 4.83556 8H19.1644C19.6259 8 20 7.57915 20 7.06V6.94C20 6.42085 19.6259 6 19.1644 6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1813_11512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHamburger);
export default __webpack_public_path__ + "static/media/whiteHamburger.912b5addb5ca5c18cf0bc445688dbeca.svg";
export { ForwardRef as ReactComponent };